import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, provideZoneChangeDetection } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { environment } from '../environments/environment';

import { AuthInterceptorService, LanguageService } from '@frontend/common';
import { LanguageInterceptorService } from '@frontend/common';
import { BrandDisplayService, JwtInterceptor } from '@frontend/common';
import { NOTIFICATION_TARGETS_OPENED_HERE } from '@frontend/common';
import { ErrorInterceptor } from '@frontend/common';

import { EnvironmentModule } from '@frontend/environment';
import { NavigationModule } from '@frontend/common';
import { FooterModule } from '@frontend/common';
import { AnnouncementBannerComponent, provideReleaseRefresh } from '@frontend/common';
import { AuthModule } from '@frontend/common';
import { BrandingModule } from '@frontend/common';

import { TranslocoService, TRANSLOCO_LOADER } from '@jsverse/transloco';
import { TranslocoCustomLoader, TranslocoRootModule } from "@frontend/angular-translations";

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    EnvironmentModule.withConfig({
      appDomain: environment.appDomain,
      appKey: environment.appKey,
      appUrl: environment.appUrl,
      apiUrl: environment.apiUrl,
      name: environment.name,
      production: environment.production,
      imageHostIdentifier: environment.imageHostIdentifier,
    }),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TranslocoRootModule,
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    NavigationModule,
    AuthModule,
    FooterModule,
    AnnouncementBannerComponent,
    BrandingModule,
    // HomeInterculturalistModule,
    // ContentModule, // for the homepage carousel
    // CarouselModule,
  ],
  providers: [
    provideZoneChangeDetection(),
    { provide: Window, useValue: window },
    // A stale tab moves onto the deployed release at its next navigation
    provideReleaseRefresh(),
    // The notification targets this site has pages for
    { provide: NOTIFICATION_TARGETS_OPENED_HERE, useValue: ['news', 'feature-requests', 'community-inputs', 'cultures', 'topics'] },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true,},
    { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptorService, multi: true,},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoCustomLoader,deps: [HttpClient]},
    { provide: APP_INITIALIZER, useFactory: (transloco : TranslocoService, languageService: LanguageService) =>
        () => {
          let activeLanguageObject = languageService.activeLanguageObjectSynchronously;
          let lang = activeLanguageObject?.languageKey ? activeLanguageObject.languageKey: transloco.getDefaultLang();
          transloco.setActiveLang(lang);
          return transloco.load(lang).toPromise();
        },
        deps: [TranslocoService,LanguageService,Location],
        multi: true
    },
    { provide: APP_INITIALIZER, useFactory: (brandDisplayService: BrandDisplayService) =>
        () => {
          let subdomain;
          let hostSplit = window.location.host.split('.'); // ['megacorp','interculturalist','com'] or  ['mySubdomain', 'localhost:8008']
          if ((hostSplit.length>2) || (hostSplit.length>1 && hostSplit.find(part=>part.indexOf('localhost')>-1))){
            subdomain = window.location.host.split('.')[0];
          };
          brandDisplayService.setSubdomain(subdomain);
          return brandDisplayService.getBranding()
        },
          deps: [BrandDisplayService],
          multi: true
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
